import { render, staticRenderFns } from "./Reproved.vue?vue&type=template&id=9202f068&scoped=true"
import script from "./Reproved.vue?vue&type=script&lang=js"
export * from "./Reproved.vue?vue&type=script&lang=js"
import style0 from "./Reproved.vue?vue&type=style&index=0&id=9202f068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9202f068",
  null
  
)

export default component.exports